import type { MouseEvent } from 'react';

import classNames from 'classnames';

import DesktopLoginButton from './DesktopLoginButton';
import MobileLoginButton from './MobileLoginButton';

import STYLES from './LoginButton.module.scss';

export type Props = {
  onLoginClick: (e: MouseEvent<HTMLButtonElement>) => void;
  loginText: string;
  accountText: string;
  isLoggedIn?: boolean;
  profilePictureUrl: string | null;
  onProfilePictureError: () => void;
  loginButtonVariant?: string;
};

// `loginButtonVariant` is separated from the rest of the props so that only the mWeb button
// can receive it. GATE-1359 is an mWeb-only experiment: the desktop button must always render
// the control, and destructuring the variant out here makes that structurally impossible to
// get wrong rather than relying on convention.
const LoginButton = ({ loginButtonVariant, ...sharedProps }: Props) => {
  const { accountText, isLoggedIn, loginText } = sharedProps;
  const a11yLabel = isLoggedIn ? accountText : loginText;

  return (
    <>
      <li
        id="login-button-nav-item"
        className={classNames({
          [STYLES['LoginButton__desktop--logged-in']]: isLoggedIn,
          [STYLES.LoginButton__desktop]: !isLoggedIn,
        })}
      >
        <DesktopLoginButton {...sharedProps} />
      </li>
      <li id="account-button-nav-item" className={STYLES.LoginButton__mobile}>
        <MobileLoginButton
          {...sharedProps}
          a11yLabel={a11yLabel}
          loginButtonVariant={loginButtonVariant}
        />
      </li>
    </>
  );
};

export default LoginButton;
